import React, { ReactNode } from 'react'

import classNames from 'classnames'
import './badge.scss'

export type BadgeColors = 'green' | 'red' | 'gray' | 'yellow'

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children: string | ReactNode
  color: BadgeColors
  solid?: boolean
  capitalize?: boolean
}

const Badge: React.FC<BadgeProps> = (props: BadgeProps) => {
  return (
    <div
      className={classNames(
        {
          appBadge: true,
          [props.color]: true,
          solid: !!props.solid,
          capitalize: !!props.capitalize,
        },
        props.className
      )}
    >
      {props.children}
    </div>
  )
}

export default Badge
